/* ============================================================
   AQUAGRID — app logic (vanilla JS)
   ============================================================ */
(function () {
  'use strict';
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  let curLang = 'es';
  const t = (en, es) => (curLang === 'en' ? en : es);

  /* ---------- mobile drawer ---------- */
  const burger = $('#burger'), drawer = $('#drawer');
  if (burger) {
    const toggle = (open) => {
      burger.classList.toggle('open', open);
      drawer.classList.toggle('open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    };
    burger.addEventListener('click', () => toggle(!drawer.classList.contains('open')));
    $$('#drawer a').forEach((a) => a.addEventListener('click', () => toggle(false)));
  }

  /* ---------- industries: graphic tabs + panels ---------- */
  const tabsEl = $('#indTabs'), panelsEl = $('#indPanels');
  const META = window.AG_INDUSTRY_META || {};
  function iconSVG(inner, cls) {
    return '<svg class="' + (cls || '') + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">' + inner + '</svg>';
  }
  // Tabs/panels may be server-rendered (Shopify Liquid blocks). Only build
  // from AG_INDUSTRIES when the container is empty (standalone fallback); the
  // click handler below is wired either way so switching always works.
  if (tabsEl && !tabsEl.children.length && window.AG_INDUSTRIES) {
    AG_INDUSTRIES.forEach((ind, i) => {
      const m = META[ind.id] || {};
      const tb = document.createElement('button');
      tb.className = 'ind-tab' + (i === 0 ? ' active' : '');
      tb.dataset.idx = i;
      tb.innerHTML = iconSVG(m.icon || '', 'ti') + '<span>' + ind.tab + '</span>';
      tabsEl.appendChild(tb);

      const p = document.createElement('div');
      p.className = 'ind-panel' + (i === 0 ? ' active' : '');
      p.dataset.idx = i;
      p.innerHTML =
        '<div class="ind-card">' +
          '<div class="ind-head">' +
            '<div class="ind-badge">' + iconSVG(m.icon || '') + '</div>' +
            '<div class="htext"><div class="tagline">' + ind.tagline + '</div></div>' +
            '<div class="ind-stat"><div class="sv">' + (m.sv || '') + '</div><div class="sl">' + (m.sl || '') + '</div></div>' +
          '</div>' +
          '<div class="ind-media">' +
            '<div class="ind-photo"><image-slot id="ag-ind-' + ind.id + '" shape="rect" fit="cover" src="' + (m.photoUrl || '') + '" placeholder="' + (m.photo || 'imagen') + '"></image-slot></div>' +
            '<div class="ind-colwrap">' +
              '<div class="ind-col"><div class="k">Corrientes que tratamos</div><p>' + ind.treat + '</p></div>' +
              '<div class="ind-col"><div class="k">Dolor que reemplazamos</div><p>' + ind.pain + '</p></div>' +
              '<div class="ind-col"><div class="k">Lo que entrega Aquagrid</div><p>' + ind.deliver + '</p></div>' +
            '</div>' +
          '</div>' +
          '<div class="ind-spec"><b>Ficha técnica —</b> ' + ind.spec + '</div>' +
        '</div>';
      panelsEl.appendChild(p);
    });
  }
  if (tabsEl) {
    tabsEl.addEventListener('click', (e) => {
      const b = e.target.closest('.ind-tab');
      if (!b) return;
      const idx = b.dataset.idx;
      $$('.ind-tab', tabsEl).forEach((x) => x.classList.toggle('active', x === b));
      $$('.ind-panel', panelsEl).forEach((x) => x.classList.toggle('active', x.dataset.idx === idx));
    });
  }

  /* ---------- comparison (visual) ---------- */
  const vsSwitch = $('#vsSwitch'), vsPanel = $('#vsPanel'), vsTableBtn = $('#vsTableBtn'), vsFull = $('#vsFull');
  let vsCur = 0;
  const okIc = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 8.5l3.5 3.5L13 4"/></svg>';
  const noIc = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4l8 8M12 4l-8 8"/></svg>';
  function renderVS() {
    if (!vsPanel || !window.AG_VS) return;
    const vs = AG_VS, rv = vs.rivals[vsCur];
    let rows = '';
    vs.dims.forEach((d, i) => {
      rows +=
        '<div class="vs-row"><div class="rl"><span class="dl">' + d.label + '</span></div>' +
        '<div class="vs-bars">' +
          '<div class="vs-bar ag"><div class="track"><div class="fill" data-w="' + d.ag + '"></div></div><span class="vv">' + d.agv + '</span></div>' +
          '<div class="vs-bar rv"><div class="track"><div class="fill" data-w="' + rv.vals[i] + '"></div></div><span class="vv">' + rv.v[i] + '</span></div>' +
        '</div></div>';
    });
    vsPanel.innerHTML =
      '<div class="vs-head">' +
        '<div class="vs-ag"><div class="who">' + t('Our solution', 'Nuestra solución') + '</div><div class="nm">' + vs.agName + '</div><div class="sub">' + vs.agSub + '</div></div>' +
        '<div class="rival"><div class="who">' + t('Conventional', 'Convencional') + '</div><div class="nm">' + rv.name + '</div><div class="sub">&nbsp;</div></div>' +
      '</div>' +
      '<div class="vs-rows">' + rows + '</div>' +
      '<div class="vs-foot">' +
        '<div class="vs-ag"><div class="ttl">' + t('Metals as by-product', 'Metales como subproducto') + '</div><div class="val">' + okIc + t('YES · sellable', 'SÍ · valorizable') + '</div></div>' +
        '<div class="rival"><div class="ttl">&nbsp;</div><div class="val">' + noIc + rv.metals + '</div></div>' +
      '</div>';
    setTimeout(() => { $$('.fill', vsPanel).forEach((f) => { f.style.width = f.dataset.w + '%'; }); }, 50);
  }
  if (vsSwitch && window.AG_VS) {
    AG_VS.rivals.forEach((r, i) => {
      const b = document.createElement('button');
      b.className = 'vs-opt' + (i === 0 ? ' active' : '');
      b.dataset.idx = i; b.textContent = r.name;
      vsSwitch.appendChild(b);
    });
    vsSwitch.addEventListener('click', (e) => {
      const b = e.target.closest('.vs-opt'); if (!b) return;
      vsCur = +b.dataset.idx;
      $$('.vs-opt', vsSwitch).forEach((x) => x.classList.toggle('active', x === b));
      renderVS();
    });
  }
  if (vsTableBtn && vsFull) {
    vsTableBtn.addEventListener('click', () => {
      const open = vsFull.classList.toggle('open');
      vsTableBtn.textContent = open ? t('Hide technical table', 'Ocultar tabla técnica')
                                    : t('View full technical table', 'Ver tabla técnica completa');
    });
  }

  /* populate industry selects (ROI + form) */
  (function fillIndustrySelects() {
    const roiSel = $('#cIndustry'), formSel = $('#fIndustry');
    if (roiSel && window.AG_INDUSTRIES) {
      roiSel.innerHTML = '';
      AG_INDUSTRIES.forEach((ind, i) => {
        const o = document.createElement('option');
        o.value = ind.id; o.textContent = ind.tab; if (i === 1) o.selected = true;
        roiSel.appendChild(o);
      });
    }
    if (formSel && window.AG_INDUSTRIES) {
      AG_INDUSTRIES.forEach((ind) => {
        const o = document.createElement('option');
        o.value = ind.id; o.textContent = ind.tab;
        formSel.appendChild(o);
      });
    }
  })();

  /* ---------- process accordion ---------- */
  const procStages = $$('#procStages .proc-stage');
  const procNodes = $$('.ps-node');
  function setStage(idx) {
    procStages.forEach((s) => s.classList.toggle('active', +s.dataset.stage === idx));
    procNodes.forEach((n) => {
      const c = n.querySelector('circle');
      if (c) c.setAttribute('stroke', +n.dataset.node === idx ? '#48A6CB' : 'rgba(170,200,215,0.3)');
    });
  }
  procStages.forEach((s) => {
    s.addEventListener('click', () => setStage(+s.dataset.stage));
    s.addEventListener('mouseenter', () => setStage(+s.dataset.stage));
  });

  /* ---------- ROI calculator ---------- */
  const fmtUSD = (n) => {
    const a = Math.abs(n), sign = n < 0 ? '\u2212' : '';
    if (a >= 1e6) return sign + '$' + (a / 1e6).toFixed(a >= 1e7 ? 0 : 1) + 'M';
    if (a >= 1e3) return sign + '$' + Math.round(a / 1e3) + 'k';
    return sign + '$' + Math.round(a);
  };
  const fmtM3 = (n) => {
    if (n >= 1e6) return (n / 1e6).toFixed(1) + 'M m³';
    if (n >= 1e3) return Math.round(n / 1e3) + 'k m³';
    return Math.round(n) + ' m³';
  };
  const fmtTons = (n) => (n >= 1000 ? (n / 1000).toFixed(1) + 'k t' : Math.round(n) + ' t');

  const cIndustry = $('#cIndustry'), cVolume = $('#cVolume'), cYears = $('#cYears');
  function setOut(sel, val) { const el = $(sel); if (el) el.textContent = val; }
  function calcROI() {
    if (!cIndustry || !window.AG_ROI) return;
    const cfg = AG_ROI, ind = cfg.byIndustry[cIndustry.value] || cfg.byIndustry.steel;
    const V = +cVolume.value, years = +cYears.value;
    const modules = Math.max(1, Math.ceil(V / cfg.moduleM3day));
    const annualWater = V * cfg.operatingDays;
    const annualSaving = annualWater * (ind.avoided - cfg.omCost);
    const capex = modules * cfg.capexPerModule;
    const netReturn = annualSaving * years - capex;
    const payback = annualSaving > 0 ? capex / annualSaving : 0;
    $('#cVolVal').innerHTML = V + '<span class="u">m³/día</span>';
    $('#cVolMods').textContent = '≈ ' + modules + ' ' + t('module', 'módulo') + (modules > 1 ? 's' : '') + ' AG-Skid';
    $('#cYrVal').innerHTML = years + '<span class="u">' + t('years', 'años') + '</span>';
    setOut('#oNet', fmtUSD(netReturn));
    setOut('#oCapex', fmtUSD(capex));
    setOut('#oAnnual', fmtUSD(annualSaving) + t('/yr', '/año'));
    setOut('#oPayback', payback.toFixed(1) + t(' yr', ' años'));
    setOut('#oWater', fmtM3(annualWater * years));
    setOut('#oMetals', ind.metals < 0.1 ? '—' : fmtTons(annualWater * ind.metals * years / 1000));
  }
  [cIndustry, cVolume, cYears].forEach((el) => el && el.addEventListener('input', calcROI));

  /* ---------- count-up ---------- */
  function countUp(el) {
    const target = parseFloat(el.dataset.count);
    const prefix = el.dataset.prefix || '', suffix = el.dataset.suffix || '';
    const dur = 1100, t0 = performance.now();
    (function tick(tt) {
      const k = Math.min(1, (tt - t0) / dur), e = 1 - Math.pow(1 - k, 3);
      el.textContent = prefix + Math.round(target * e) + suffix;
      if (k < 1) requestAnimationFrame(tick);
    })(t0);
  }

  /* ---------- compliance drip counter ---------- */
  function dripCounter() {
    const el = $('#dripCount'); if (!el) return;
    const target = 1108800, t0 = performance.now(), dur = 2000;
    (function tk(t) {
      const k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3);
      el.textContent = Math.round(target * e).toLocaleString('en-US') + ' m³';
      if (k < 1) requestAnimationFrame(tk);
    })(t0);
  }

  /* ---------- scroll reveal (rect-based; robust across embeds) ---------- */
  function revealVisible() {
    const vh = window.innerHeight || document.documentElement.clientHeight;
    $$('.reveal:not(.in)').forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < vh * 0.92 && r.bottom > -40) {
        el.classList.add('in');
        $$('[data-count]', el).forEach(countUp);
        if (el.dataset.count) countUp(el);
        if (el.querySelector && el.querySelector('#dripCount') && !el.dataset.dripped) { el.dataset.dripped = '1'; dripCounter(); }
      }
    });
    $$('[data-count]:not(.counted)').forEach((el) => {
      if (el.closest('.reveal')) return;
      const r = el.getBoundingClientRect();
      if (r.top < vh * 0.92 && r.bottom > -40) { el.classList.add('counted'); countUp(el); }
    });
  }
  window.addEventListener('scroll', revealVisible, { passive: true });
  window.addEventListener('resize', revealVisible);
  window.addEventListener('load', revealVisible);

  /* ---------- evaluation form → water success ---------- */
  const form = $('#evalForm'), success = $('#formSuccess');
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      let ok = true;
      $$('[required]', form).forEach((f) => {
        const bad = !f.value.trim() || (f.type === 'email' && !/^[^@]+@[^@]+\.[^@]+$/.test(f.value));
        f.classList.toggle('err', bad);
        if (bad) ok = false;
      });
      if (!ok) return;
      form.style.display = 'none';
      success.classList.add('show');
    });
    $$('input,select,textarea', form).forEach((f) =>
      f.addEventListener('input', () => f.classList.remove('err')));
  }

  /* ---------- popup / lead modal ---------- */
  const modal = $('#leadModal');
  if (modal) {
    const closeModal = () => modal.classList.remove('open');
    $('#modalClose').addEventListener('click', closeModal);
    modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeModal(); });
    // #modalForm is a real Shopify {% form 'customer' %} — it posts natively to
    // create the subscriber; no JS interception. On a posted reload the section
    // re-opens the modal + sets the ag-pop flag, so the auto-show below is skipped
    // and the success state stays visible.
    let shown = false;
    try { shown = sessionStorage.getItem('ag-pop') === '1'; } catch (e) {}
    if (!shown) {
      let fired = false;
      const fire = () => {
        if (fired || document.body.style.overflow === 'hidden') return;
        fired = true;
        try { sessionStorage.setItem('ag-pop', '1'); } catch (e) {}
        modal.classList.add('open');
      };
      setTimeout(fire, 14000);
      const onScroll = () => {
        const max = document.documentElement.scrollHeight - window.innerHeight;
        if (max > 0 && window.scrollY > max * 0.4) { fire(); window.removeEventListener('scroll', onScroll); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  /* ---------- EN/ES toggle ---------- */
  $$('[data-i18n]').forEach((el) => { el.dataset.es = el.innerHTML; });
  $$('[data-i18n-ph]').forEach((el) => { el.dataset.esPh = el.getAttribute('placeholder') || ''; });
  function applyLang(lang) {
    curLang = lang;
    document.documentElement.lang = lang;
    $$('[data-i18n]').forEach((el) => {
      const key = el.dataset.i18n;
      el.innerHTML = lang === 'en' ? (AG_I18N_EN[key] != null ? AG_I18N_EN[key] : el.dataset.es) : el.dataset.es;
    });
    $$('[data-i18n-ph]').forEach((el) => {
      const key = el.dataset.i18nPh;
      el.setAttribute('placeholder', lang === 'en' ? (AG_I18N_EN[key] != null ? AG_I18N_EN[key] : el.dataset.esPh) : el.dataset.esPh);
    });
    $$('.lang button').forEach((b) => b.classList.toggle('active', b.dataset.lang === lang));
    if (vsFull) vsFull.classList.remove('open');
    calcROI();
    renderVS();
    try { localStorage.setItem('ag-lang', lang); } catch (e) {}
  }
  $$('.lang button').forEach((b) => b.addEventListener('click', () => applyLang(b.dataset.lang)));

  /* ---------- init ---------- */
  let saved = 'es';
  try { saved = localStorage.getItem('ag-lang') || 'es'; } catch (e) {}
  renderVS();
  calcROI();
  revealVisible();
  if (saved === 'en') applyLang('en');
})();
